<template>

    <div class="accommodationArrangement">

        <el-col :span="5" style="padding:0;">

            <div class="leftmenu">
                <div class="title" @click="dialogTableVisible=true">部门组织

                </div>
                <div class="treepanel">
                    <el-tree ref="classtree" :props="classdefaultProps" :expand-on-click-node="false" @node-click="classhandleCheckChange" :data="classtreeData" node-key='id' class="combotree" highlight-current>
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span class="label-text" :class="{'icon-college': data.type == 2 || data.type == 6, 'icon-department': data.type == 3, 'icon-grade': data.type == 4, 'icon-class': data.type == 5}">{{node.label}}</span>
                        </span>
                    </el-tree>
                </div>
            </div>

        </el-col>
        <el-col :span="19" style="padding:0;">
            <div class="righttable">
                <div>
                    <div>
                        <el-form :inline="true" class="demo-form-inline" :model="searchForm">
                            <el-form-item style="width:15%">
                                <!--<span class="btn import" @click="showImport = true">-->
                                <!--导入已入住学生-->
                                <!--</span>-->
                                <el-button type="primary" icon="el-icon-upload2" @click="importStudent">导入已入住学生</el-button>
                            </el-form-item>
                            <el-form-item style="width:9%">
                                <el-button @click="AutomaticLodging">自动排宿</el-button>
                            </el-form-item>
                            <el-form-item style="width:9%">
                                <el-button @click="BatchOccupancy">批量入住</el-button>
                            </el-form-item>
                            <el-form-item label="性别:" style="width:25%">
                                <el-select v-model="searchForm.sex" placeholder="请选择" @change="search" style="width:80px">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <div class="attendanceQuery">
                                <div style="float:right;">
                                    <el-input class="input" placeholder="请输入学号或者姓名" v-model="searchForm.search" style="width:270px;margin-right: 30px;">
                                        <el-button slot="append" icon="el-icon-search" @click='search' style="height: 30px;
												background: rgb(41, 173, 238);
												color: white;
												border-bottom-left-radius: 0px;
												border-top-left-radius: 0px;
												border-color: rgb(41, 173, 238);
											}">查询</el-button>
                                    </el-input>
                                    <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出Excel</el-button>
                                </div>
                                <div style="clear:both;"></div>

                            </div>
                        </el-form>
                    </div>

                    <el-table border stripe :data="tableData" header-row-class-name="table-header" fit @selection-change="changeSel">
                        <el-table-column type="selection" width="55" align="center">
                        </el-table-column>
                        <el-table-column type="index" label="序号" width="55" align="center">
                        </el-table-column>
                        <el-table-column prop="studentName" label="姓名" align="center">
                            <span class="studentname" slot-scope="scope" @click="studentInfoDialog(scope.row.id, $event)">{{scope.row.studentName}}</span>
                        </el-table-column>
                        <el-table-column prop="studentCode" label="学号" align="center">
                        </el-table-column>
                        <el-table-column prop="sex" label="性别" align="center" :formatter="formatSex">
                        </el-table-column>
                        <el-table-column prop="departmentParentName" label="学院" align="center" v-if="user.style !== K12TYPE">
                        </el-table-column>
                        <el-table-column prop="departmentName" label="系部" align="center" v-if="user.style !== K12TYPE">
                        </el-table-column>
                        <el-table-column prop="gradeName" label="年级" align="center">
                        </el-table-column>

                        <el-table-column prop="className" label="班级" align="center">
                        </el-table-column>
                        <el-table-column prop="phoneNum" label="联系电话" align="center">
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <a href="javascript:void(0);" @click="singleCheckIn(scope.row)" style="color: #00a0e9;text-decoration:underline">入住</a>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-container ">
                        <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :page="page"></v-pagination>
                    </div>

                </div>
            </div>
        </el-col>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="自动排宿" :visible.sync="showRoomEditDialog" width="488px" height="420px" :before-close="back" left>
            <div class="autops">
                <el-form ref="form" :model="searchForm" label-width="80px" style="width:100%">

                    <el-form-item label="学生性别:">
                        <el-col :span="10">
                            <el-select v-model="searchForm.sex" placeholder="请选择学生性别" @change="loadData">
                                <el-option label="男" value="1"></el-option>
                                <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="9">
                            已选人数:
                            <font color="red">{{userTotal}}</font>
                        </el-col>
                    </el-form-item>

                    <el-form-item label="目标楼栋:">
                        <el-col :span="10">
                            <el-select v-model="searchForm.houseId" placeholder="请选择目标楼栋" @change="autoChange">
                                <el-option v-for="item in houseOptions1" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="9">
                            <span v-if="!isAutoFlagBtn"> 剩余:
                                <font color="aqua" style="font-size: 12px">{{houseCountNum}},可排宿 </font>
                            </span>
                            <span v-if="isAutoFlagBtn"> 剩余:
                                <font color="red" style="font-size: 12px">{{houseCountNum}},不可排宿 </font>
                            </span>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="排宿规则:" v-if="user.style !== K12TYPE">
                        (按从上往下优先级)
                        <br>1、相同班级学生优先安排同一寝室
                        <br>2、相同系部学生优先安排同一寝室
                        <br>3、相同学院学生优先安排同一寝室
                    </el-form-item>
                    <el-form-item label="排宿规则:" v-else>
                        (按从上往下优先级)
                        <br>1、相同班级学生优先安排同一寝室
                        <br>2、相同年级学生优先安排同一寝室
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer">
                <div style="width: 100%;height: 40px;line-height: 40px;padding-bottom: 0px">
                    <el-button @click="submitAutoForm" type="primary" class="u-btn" :disabled="isAutoFlagBtn">确定</el-button>
                    <el-button @click="back()" class="u-btn">返回</el-button>
                </div>
            </span>

        </el-dialog>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="学生入住" :visible.sync="showBatchOccupancyDialog" width="1200px" height="660px;" :before-close="back1" left>
            <div class="autops">
                <el-row :gutter="21" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
                    <el-col :span="11" style="padding:0;">
                        <div style="width: 100%;height: 30px;background-color:#f3f3f3 ;margin-bottom: 10px;line-height: 30px;">
                            <font style="font-weight: bold;">待入住:</font>
                            <font v-if="changeSelVal2.length!=0">已选(
                                <font color="red">{{changeSelVal2.length}}</font>)人</font>
                        </div>
                        <el-table border stripe :data="tableData1" header-row-class-name="table-header" ref="table1" fit @selection-change="changeSel2" class="stuInhouse">
                            <el-table-column type="selection" width="40" align="center"> </el-table-column>
                            <el-table-column type="index" label="序号" width="45" align="center">
                            </el-table-column>
                            <el-table-column prop="studentName" label="姓名" width="50" align="center">

                            </el-table-column>
                            <el-table-column prop="studentCode" label="学号" align="center">
                            </el-table-column>
                            <el-table-column prop="sex" label="性别" align="center" :formatter="formatSex">
                            </el-table-column>
                            <el-table-column prop="departmentParentName" label="学院" align="center" v-if="user.style !== K12TYPE">
                            </el-table-column>
                            <el-table-column prop="departmentName" label="系部" align="center" v-if="user.style !== K12TYPE">
                            </el-table-column>
                            <el-table-column prop="gradeName" label="年级" align="center">
                            </el-table-column>
                            <el-table-column prop="className" label="班级" align="center">
                            </el-table-column>
                        </el-table>
                        <div class="pagination-container " v-if="this.ruzhuType==='batch2'">
                            <v-pagination @pageChange="onCurrentChange" :total="total" :isShow="showPagination" :size="size"></v-pagination>
                        </div>
                    </el-col>
                    <el-col :span="2" style="width: 7.33333%;text-align:center;">
                        <div>
                            <img src="../../../static/images/bathocco/ruzhu.png" style="margin-top:271px;cursor:pointer;" @click="ruzhu()">
                            <p style="margin-bottom: 53px;">入住</P>
                            <el-button @click="back1" type="primary" style="width: 70px">完成</el-button>
                        </div>
                    </el-col>
                    <el-col :span="13" style="width:46.83333%;padding:0;border:1px dashed #cccccc; height: 570px;overflow: auto;">
                        <div v-if="this.roleCode==='housekeeper'">
                            <el-form :inline="true" class="demo-form-inline" :model="formData" label-width="44px">
                                <el-form-item label="楼栋:" class="icon-blue-building" style="margin:0 15px 0 10px;">
                                    <el-select v-model="formData.houseId" placeholder="请选择" @change="changeFloor" clearable style="width: 150px;">
                                        <el-option v-for="item in houseOptions2" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="楼层:" style="width:24%">
                                    <el-select v-model="formData.floorId" placeholder="请选择" style="width:80px" clearable>
                                        <el-option v-for="item1 in floorList" :key="item1.value" :label="item1.label" :value="item1.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <!-- <el-form-item label="宿舍名:" style="width:29%">
                                    <el-input v-model="formData.domitoryCode" placeholder="请输入" style="width: 80px"></el-input>
                                </el-form-item>
                                <el-form-item style="width:14%">
                                    <el-button @click="getDomitory">查询</el-button>
                                </el-form-item> -->
                                <div style="width: 100%;height: 40px;background-color:#f3f3f3 ;margin-bottom: 10px; line-height: 40px;">
                                    <div style="font-weight:bold;size: 20px;margin-left: 10px;float: left">选择入住宿舍:</div>
                                    <div v-if="this.ruzhuType==='batch'||this.ruzhuType==='batch2'" style="float: left">(剩余
                                        <font color="red">{{restBedSize}}</font>已选
                                        <font color="red">{{selBedSize}}</font>)

                                    </div>
                                    <div style="float:right;">
                                        <el-input class="input" placeholder="请输入宿舍名称查询" v-model="formData.domitoryCode" style="width:270px;margin-right: 5px;">
                                            <el-button slot="append" icon="el-icon-search" @click='getDomitory' style="height: 30px;
                                                    background: #f7f7f7;
                                                    color: #333;
                                                    border-bottom-left-radius: 0px;
                                                    border-top-left-radius: 0px;
                                                    border-color: #dbdbdb;
                                                }">查询</el-button>
                                        </el-input>
                                    </div>
                                </div>
                            </el-form>

                        </div>
                        <div v-if="this.roleCode==='admin' || this.roleCode === 'logisticsadmin'">
                            <el-form :inline="true" class="demo-form-inline" :model="formData">
                                <el-form-item label="校区:" style="width:43%;margin-left:10px;" class="icon-blue-schoolArea">
                                    <el-select v-model="formData.schoolNum" placeholder="请选择" style="width:135px" @change="changeHouse" clearable>
                                        <el-option v-for="item in schoolAreaOption" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item label="楼栋:" style="width:45%" class="icon-blue-building">
                                    <el-select v-model="formData.houseId" placeholder="请选择" style="width:130px" clearable>
                                        <el-option v-for="item in houseOptions" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <!-- <el-form-item label="宿舍名:" style="width:28%">
                                    <el-input v-model="formData.domitoryCode" placeholder="请输入" style="width: 80px"></el-input>
                                </el-form-item>
                                <el-form-item style="width:10%">
                                    <el-button @click="getDomitory">查询</el-button>
                                </el-form-item> -->
                                <div style="width: 100%;height: 40px;background-color:#f3f3f3 ;margin-bottom: 10px; line-height: 40px;">
                                    <div style="font-weight:bold;size: 20px;margin-left: 10px;float: left">选择入住宿舍:</div>
                                    <div v-if="this.ruzhuType==='batch'||this.ruzhuType==='batch2'" style="float: left">(剩余
                                        <font color="red">{{restBedSize}}</font>已选
                                        <font color="red">{{selBedSize}}</font>)

                                    </div>
                                    <div style="float:right;">
                                        <el-input class="input" placeholder="请输入宿舍名称查询" v-model="formData.domitoryCode" style="width:270px;margin-right: 5px;">
                                            <el-button slot="append" icon="el-icon-search" @click='getDomitory' style="height: 30px;
                                                    background: #f7f7f7;
                                                    color: #333;
                                                    border-bottom-left-radius: 0px;
                                                    border-top-left-radius: 0px;
                                                    border-color: #dbdbdb;
                                                }">查询</el-button>
                                        </el-input>
                                    </div>
                                </div>
                            </el-form>

                        </div>
                        <div style="text-align:center;">
                            <ul class="ruzhusushe">
                                <li @click="Select(item)" v-for="item in dormitoryList">
                                    <div class="limask">
                                    </div>
                                    <span class="sushehao">{{item.dormitoryName}}</span>
                                    <el-badge :value="item.emptyBed" :max="99" :class="value>0?'item':'item red'">
                                        <img src="../../../static/images/bathocco/sushe2.png" class="badgeimage" />
                                    </el-badge>
                                    <img src="../../../static/images/bathocco/selected.png" class="selected" v-if="item.selectFlag">
                                </li>
                            </ul>
                            <div style='clear:both;'></div>

                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="showClose" title="自动排宿" :visible.sync="showAutoPro" width="550px" height="330px" left :before-close="back2">
            <div style="width:520px;height:300px;text-align: center">
                <div style="margin-top:61px">
                    <span class="el-icon-warning" style="color: #FD8C25;font-size: 45px;"></span>
                </div>
                <!--<div style="margin-top:24px;color:#26aef3;font-size: 12px">-->
                <!--{{autoPer}}%-->
                <!--</div>-->
                <div style="margin-top: 24px;">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="autoPer" status="success"></el-progress>
                </div>
                <div style="text-align: center;margin-top: 20px;font-size: 16px;color: #666666;">{{processMsg}}</div>
            </div>

        </el-dialog>

        <!-- 导入 -->
        <import-upload :showImport.sync="showImport" :importObj="importObj" :warningMsg="warningMsg" @importFinishCallback="afterImport"></import-upload>
    </div>

</template>

<script>
import Api from '@/api';
import axios from 'axios';
import basetable from '@/mixins/base-table';
import uploadfile from '@/components/upload_img/uploadfile.vue'
// import AutomaticLodging from '@/components/AutomaticLodging/index.vue'
// import BatchOccupancysearch from '@/components/BatchOccupancysearch/index.vue'
import importUpload from '@/components/importUpload/importUpload.vue';
import studentInfo from '@/components/studentInfo/studentInfo.vue'
import {
    session
} from '@/util'
import { mapState } from 'vuex';

export default {
    components: {
        vStudentInfo: studentInfo,
        importUpload
        // AutomaticLodging,
        // BatchOccupancysearch
    },

    mixins: [basetable],
    data () {
        let user = session("user");
        return {
            user,
            processMsg: '',
            importFileName: '',
            File: null, // 最终上传的formdata
            showImport: false,
            importObj: null,
            warningMsg: "",
            importErrorMsg: '',
            showStudentInfoDialog: false,
            studentInfoEventTaret: null,
            currentStudentRow: null,
            restBedSize: 0,
            selBedSize: 0,
            ruzhuType: '',
            batchData: {
                schoolId: '',
                dormitoryIdList: [],
                schoolNum: '',
                studentIdList: []
            },
            changeSelVal2: [],
            changeSelIndex: [],
            selStudent2: [],
            selStudent: [],
            dormitorySelectIds: [],
            dormitoryList: [],
            formData: {
                houseId: "",
                domitoryCode: "", // 宿舍号
                floorId: "", // 楼层
                schoolNum: ""
            },
            value: 3,
            lingvalue: 0,
            floorList: [],
            tableData1: [],

            schoolAreaOption: [],
            deptProps: {
                label: 'deptName',
                children: 'zones',
                isLeaf: 'leaf'
            }, // 部门数据
            buildingUnitSelectShow: false,
            houseCountNum: 0,
            isAutoFlagBtn: true,

            userTotal: 0,
            batchList: [],
            houseOptions1: [],
            houseOptions: [],
            houseOptions2: [],
            searchForm: {
                houseId: '',
                sex: '1',
                search: '',
                departmentId: '',
                gradeId: '',
                classId: '',
                schoolId: '',
                schoolNum: ''
            },
            roleCode: '',
            options: [{
                value: '1',
                label: '男'
            }, {
                value: '2',
                label: '女'
            }],
            showBatchOccupancyDialog: false,
            showRoomEditDialog: false,
            tableData: [],
            treedata: [],
            searchType: 'init',
            classdefaultProps: {
                label: 'directorName',
                isLeaf: 'leaf',
                children: "nextLevels"
            },
            classtreeData: [],
            currentStudentInfo: {
                student_name: '', //姓名
                nation: "", // 民族
                student_code: '', //学号
                class_Name: '', // 班级名称
                sex: '', //性别：1为男，2为女
                phone_num: '', //手机号码
                birthdate: '', // 生日
                in_time: "", // 入宿时间
                bed_name: "", //床位名称
                image: "", // 图片
                remark: '', //备注
                entrance_school_date: "" // 入学时间
            },
            lunxunrequesttimer: null,
            showAutoPro: false,
            autoPer: 0,
            showClose: false
        };

    },
    computed: {
        ...mapState([
            'K12TYPE',
            'UNK12TYPE'
        ])
    },
    watch: {

    },
    methods: {
        search () {
            this.page = 1;
            this.loadData();
        },
        afterImport () {
            this.search();
        },
        importStudent () {
            this.showImport = true;
            this.warningMsg = "建议一次性导入不超过10000条数据";
            this.importObj = {
                title: '批量导入已入住学生',
                text: '点击下载导入模板',
                url: '/static/已入住学生导入模板.xlsx',
                key: 'oldCheckinStudentFile',
                api: Api.AccommodationManagement.importOldCheckinStudent
            };

        },

        //导出
        exportExcel () {
            let user = session('user');
            let schoolId = user.schoolId;
            let str = "schoolId=" + schoolId + "&&sex=" + this.searchForm.sex;
            if (this.searchForm.departmentId) {
                str += "&&departmentId=" + this.searchForm.departmentId;
            }
            if (this.searchForm.schoolNum !== '') {
                str += "&&schoolNum=" + this.searchForm.schoolNum;
            }
            if (this.searchForm.gradeId) {
                str += "&&gradeId=" + this.searchForm.gradeId;
            }
            if (this.searchForm.classId) {
                str += "&&classId=" + this.searchForm.classId;
            }

            if (this.searchForm.search) {
                str += "&&search=" + this.searchForm.search;
            }
            Api.AccommodationManagement.exportWaitCheckinList(str, 0, 999999).then(res => {
                if (res.code === 0) {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    this.$common.globalExportExl(key, value, '学生住宿安排');
                }
            });
        },
        // downloads(data) {
        // 	if (!data) {
        // 		return
        // 	}
        // 	let url = window.URL.createObjectURL(new Blob([data]));
        // 	let link = document.createElement('a');
        // 	link.style.display = 'none';
        // 	link.href = url;
        // 	link.setAttribute('download', '学生住宿安排.xls');
        // 	document.body.appendChild(link);
        // 	link.click();
        // },

        // 导入
        uploadFile () {
            if (!this.File || this.importFileName === '') {
                this.$message('请先选择文件！');
                return;
            }
            Api.AccommodationManagement[this.importObj.api](this.File).then((res) => {
                this.importFileName = '';
                this.File = null;
                if (res.code == 0) {
                    this.openImportSuccess(s, e);
                } else {
                    this.importErrorMsg = res.message;
                }
            });
        },
        changeExl (file) {
            var file = this.$refs.importFile.files;
            var formData = new FormData();
            formData.append(this.importObj.key, file[0]);
            this.importFileName = file[0].name;
            this.File = formData;
        },
        // 取消导入
        cancelImportDialog () {
            this.showImport = false;
            this.importFileName = '';
            this.File = null;
        },

        // 点击查看学生资料
        studentInfoDialog (studentId, event) {
            Api.attendanceQuery.getcurrentStudentInfo('userId=' + studentId)
                .then((res) => {
                    if (res.code === 0) {
                        let image = res.data.image;
                        if (image) {
                            image = image ? '/suguan/oss/d/' + image + '?token=' + session('token').accesstoken : '';
                        }
                        this.currentStudentInfo = {
                            name: res.data.student_name,
                            studentCode: res.data.student_code,
                            gender: res.data.sex,
                            bornDate: res.data.birthdate,
                            nation: res.data.nation,
                            cName: res.data.class_Name,
                            phoneNum: res.data.phone_num,
                            inDate: res.data.in_time,
                            image: image
                        }
                        this.studentDomTarget = event.target;
                        this.$emit('getcurrentStudentInfo', this.currentStudentInfo, this.studentDomTarget);
                    }else {
                        this.showTip(res.message, 'info');
                    }
                })
        },

        //批量入住与单个入住
        ruzhu () {
            let user = session('user');
            let schoolId = user.schoolId;
            if (this.ruzhuType === 'batch' || this.ruzhuType === 'batch2') { //批量入住
                let schoolNum = this.formData.schoolNum;
                this.batchData.dormitoryIdList = this.dormitorySelectIds;
                this.batchData.schoolId = schoolId;
                this.batchData.schoolNum = schoolNum;
                let selStudent2 = this.changeSelVal2;
                if (selStudent2 === null || selStudent2.length === 0) {
                    this.showTip("请选择入住的学生", 'error');
                    return;
                }
                if (this.dormitorySelectIds === null || this.dormitorySelectIds.length === 0) {
                    this.showTip("请选择入住的寝室", "error");
                    return;
                }

                if (selStudent2.length > this.selBedSize) {
                    this.showTip("入住人数不能大于已选择的寝室的可住床位数", "error");
                    return;
                }

                let studentListIds = [];
                selStudent2.map(x => {
                    studentListIds.push(x.id);
                });
                this.batchData.studentIdList = studentListIds;
                let newForm = Object.assign({}, this.batchData);
                Api.AccommodationManagement.batchCheckIn(newForm).then((res) => {
                    if (res.code === 0) {
                        if (this.ruzhuType === 'batch') {
                            let dataArr = this.tableData1;
                            this.changeSelIndex.map(item => {
                                dataArr[item] = 'delete';
                            });
                            dataArr = dataArr.filter(item => {
                                return item !== 'delete';
                            });

                            this.tableData1 = dataArr;
                        } else if (this.ruzhuType === 'batch2') {
                            this.page = 1;
                            this.size = 100;
                            this.loadData();
                        }
                        this.getDomitory();
                        this.showTip("入住成功")
                    } else {
                        this.showTip(res.message, "error");
                    }
                });
            } else if (this.ruzhuType === 'single') { //单个入住
                let str = '';
                if (this.changeSelVal2 === null || this.changeSelVal2.length === 0) {
                    this.showTip("请选择入住的学生", 'error');
                    return;
                }
                if (this.dormitorySelectIds === null || this.dormitorySelectIds.length === 0) {
                    this.showTip("请选择入住的寝室", "error");
                    return;
                }
                let studentId = this.changeSelVal2[0].id;
                let dormitoryId = this.dormitorySelectIds[0];
                if (studentId) {
                    str += "studentId=" + studentId;
                }
                if (dormitoryId) {
                    str += "&&dormitoryId=" + dormitoryId;
                }
                Api.AccommodationManagement.singleCheckIn(str).then((res) => {
                    if (res.code === 0) {
                        this.tableData1 = [];
                        this.getDomitory();
                        this.showTip("入住成功");
                    } else {
                        this.showTip(res.message, "error");
                    }
                });
            }
        },

        changeSel2 (val) {
            this.changeSelVal2 = val;
            let changeSelIndex = [];
            val.forEach((val, index) => {
                this.tableData1.forEach((v, i) => {
                    // id 是每一行的数据id
                    if (val.id == v.id) {
                        changeSelIndex.push(i);
                    }
                });
            });
            this.changeSelIndex = changeSelIndex;
        },

        changeSel (val) {
            this.selStudent = val;
        },
        getDomitory () {
            let user = session('user');
            let schoolId = user.schoolId;
            let str = "schoolId=" + schoolId;
            if (this.formData.schoolNum !== null && this.formData.schoolNum !== '' && this.formData.schoolNum !== undefined) {
                str += "&&schoolNum=" + this.formData.schoolNum;
            } else {
                if (this.roleCode === 'admin' || this.roleCode === 'logisticsadmin') {
                    this.showTip("请选择校区", "error");
                    return;
                }
            }
            if (this.formData.houseId) {
                str += "&&houseId=" + this.formData.houseId;
            } else {
                this.showTip("请选择楼栋", "error");
                return;
            }
            if (this.formData.domitoryCode) {
                str += "&&dormitoryName=" + this.formData.domitoryCode;
            }
            if (this.formData.floorId) {
                str += "&&floorId=" + this.formData.floorId;
            }
            this.showLoading();
            Api.AccommodationManagement.emptyBedDormitoryList(str).then((res) => {
                let data = res.data.list;
                let total = 0;
                if (data) {
                    data.forEach(item => {
                        item.selectFlag = false;
                        total += item.emptyBed;
                    });
                }
                this.restBedSize = total;
                this.selBedSize = 0;
                this.dormitoryList = data;
                this.dormitorySelectIds = [];
            }).finally(this.closeLoading);
        },

        //查询当前登录用户管理的楼栋
        queryHouseByManagerUser () {
            Api.summary.queryHouseByManagerUser().then(res => {
                let data = res.data;
                let option = [];
                data.map(x => {
                    let obj = {};
                    obj.value = x.houseId;
                    obj.label = x.houseName;
                    option.push(obj);
                });
                this.houseOptions2 = option;
            });
        },

        //查询校区
        querySchoolCapmus () {
            Api.AccommodationManagement.querySchoolCapmus().then((res) => {
                let data = res.data;
                let option = [];
                if (data) {
                    data.map(e => {
                        let o = {};
                        o.label = e.schoolName;
                        o.value = e.schoolNum;
                        option.push(o);
                    });
                }
                this.schoolAreaOption = option;
            });
        },
        //根据校区学校查询楼栋信息
        changeHouse (value) {
            console.log(this.schoolAreaList);
            let user = session('user');
            let schoolId = user.schoolId;
            this.searchForm.schoolId = schoolId;
            let str = "schoolId=" + schoolId;
            str += "&&schoolNum=" + value;
            Api.AccommodationManagement.getAllHouseBySchool(str).then((res) => { //查询该学校所有楼栋信息
                let data = res.data;
                let option = [];
                if (data) {
                    data.map(e => {
                        let o = {};
                        o.label = e.houseName;
                        o.value = e.houseId;
                        option.push(o);
                    });
                }
                // this.formData.houseId = option[0].value;
                this.houseOptions = option;
            });
        },

        //根据楼查询楼层信息
        changeFloor (value) {
            Api.AccommodationManagement.getFloorListByHouseId(value).then((res) => {
                let data = res.data;
                let option = [];
                if (data) {
                    data.map(e => {
                        let o = {};
                        o.label = e.floorName;
                        o.value = e.floorId;
                        option.push(o);
                    });
                }
                this.floorList = option;
            });
        },
        //有空余床位寝室列表
        emptyBedDormitoryList () {
            let user = session('user');
            let schoolId = user.schoolId;
            let str = "schoolId=" + schoolId;
            if (this.formData.houseId) {
                str += "houseId=" + this.formData.houseId;
            }
        },

        Select (item) {
            let flag = !item.selectFlag;
            if (this.ruzhuType === 'batch' || this.ruzhuType === 'batch2') {
                item.selectFlag = flag;
                //选取
                if (item.selectFlag === true) {
                    this.restBedSize = this.restBedSize - item.emptyBed;
                    this.selBedSize = this.selBedSize + item.emptyBed;
                    this.dormitorySelectIds.push(item.dormitoryId);
                } else { //取消选择
                    this.restBedSize = this.restBedSize + item.emptyBed;
                    this.selBedSize = this.selBedSize - item.emptyBed;
                    this.dormitorySelectIds.pop(item.dormitoryId);
                }
            } else if (this.ruzhuType === 'single') {
                this.dormitorySelectIds = [];
                if (flag === true) {
                    //清空所有的选中
                    this.dormitoryList.map(x => {
                        x.selectFlag = false;
                    });
                    item.selectFlag = flag;
                    this.dormitorySelectIds.push(item.dormitoryId);
                } else {
                    this.dormitoryList.map(x => {
                        x.selectFlag = false;
                    });
                }
            }

            console.log(this.dormitorySelectIds);
        },
        submitForm () {
            console.log(this.$parent)

        },

        submitAutoForm () {
            if (this.userTotal === 0) {
                this.showTip("没有待排宿的学生", "error");
                return;
            }
            if (this.userTotal > this.houseCountNum) {
                this.showTip("排宿人数不能超过该楼栋剩余的床位数", "error");
                return;
            }
            let newForm = Object.assign({}, this.searchForm);
            this.processMsg = '正在自动排宿,请勿关闭当前页面!';
            this.showLoading();
            Api.AccommodationManagement.autoCheckinDormitory(newForm).then((res) => {
                if (res.code === 0) {
                    this.showAutoPro = true;
                    var key = res.data;
                    let lunxunrequest = (key) => {
                        return Api.AccommodationManagement.getAutoCheckinProcess(key).then(res => {
                            if (res.code === 0 && res.data !== null) {
                                this.autoPer = parseInt(res.data);
                                if (this.autoPer === 100) {
                                    this.showAutoPro = false;
                                    this.showTip("排宿成功");
                                    this.searchType = "init";
                                    this.loadData();
                                    clearTimeout(this.lunxunrequesttimer);
                                } else {
                                    this.lunxunrequesttimer = setTimeout(() => {
                                        lunxunrequest(key);
                                    }, 1000)
                                }
                                return this.autoPer;
                            } else {
                                this.showTip(res.message, "error");
                                this.showClose = true;
                            }
                        });
                    }

                    this.showRoomEditDialog = false;
                    lunxunrequest(key);

                } else {
                    this.showTip(res.message, "error");
                }
            }).finally(this.closeLoading);
        },

        // openProWarningDialog(title, msg) {
        //   let html = `<div style="width:400px;height:180px;padding:30px 50px;text-align: center">
        //                       <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 25px;"></span> </div>
        //                       <div style="width:80% "> {{autoPer}}<el-progress :text-inside="true" :stroke-width="18" :percentage="autoPer" status="success"></el-progress></div>
        //                       <p>${msg}!</p>
        //                   </div>`;
        //   this.$alert(html, title, {
        //     confirmButtonText: '确定',
        //     showCancelButton: false
        //   }).then(() => {})
        // },



        autoChange (value) {
            Api.AccommodationManagement.getNoUseBedTotal(value).then((res) => {
                this.houseCountNum = res.data;
                if (this.userTotal <= this.houseCountNum) {
                    this.isAutoFlagBtn = false;
                } else {
                    this.isAutoFlagBtn = true;
                }
            });
        },
        back () {
            this.showRoomEditDialog = false;
            // this.searchForm.sex = '1';
            this.searchType = 'init';
            this.loadData();
        },
        back2 () {
            this.showAutoPro = false;
            this.searchType = 'init';
            this.loadData();
        },

        back1 () {
            this.showBatchOccupancyDialog = false;
            this.searchType = 'init';
            this.page = 1;
            this.size = 20;
            this.loadData();
        },
        singleCheckIn (row) {
            this.ruzhuType = 'single';
            this.tableData1 = [];
            this.tableData1.push(row);
            this.showBatchOccupancyDialog = true;
            this.formData = {};
            this.dormitoryList = [];
            this.searchType = 'ruzhu';
            if (this.roleCode === 'housekeeper') {
                this.queryHouseByManagerUser();
            } else if (this.roleCode === 'admin' || this.roleCode === 'logisticsadmin') {
                this.querySchoolCapmus();
            }
            this.$nextTick(() => {
                this.$refs.table1.toggleAllSelection(true); //官网方法，重点。
            });
        },
        loadData () {
            let user = session('user');
            let schoolId = user.schoolId;
            let str = "schoolId=" + schoolId + "&&sex=" + this.searchForm.sex;
            if (this.searchForm.departmentId) {
                str += "&&departmentId=" + this.searchForm.departmentId;
            }
            if (this.searchForm.schoolNum !== '') {
                str += "&&schoolNum=" + this.searchForm.schoolNum;
            }
            if (this.searchForm.gradeId) {
                str += "&&gradeId=" + this.searchForm.gradeId;
            }
            if (this.searchForm.classId) {
                str += "&&classId=" + this.searchForm.classId;
            }

            if (this.searchForm.search) {
                str += "&&search=" + this.searchForm.search;
            }

            return Api.AccommodationManagement.getWaitCheckinList(str, this.page, this.size).then(res => {
                if (res.code === 0) {
                    if (this.searchType === 'init') {
                        this.total = res.data.total;
                        this.tableData = res.data.list;
                        this.userTotal = res.data.total;
                    }
                    if (this.searchType === 'auto') {
                        this.userTotal = res.data.total;
                    }
                    if (this.searchType === 'ruzhu') {
                        this.total = res.data.total;
                        this.tableData1 = res.data.list;
                        if (this.$refs.table1) {
                            this.$nextTick(() => {
                                this.$refs.table1.toggleAllSelection(true); //官网方法，重点。
                            });
                        }

                    }
                } else {
                    this.$message(res.message);
                }
            });

        },
        classhandleCheckChange (Node) {
            // let level = Node.level;
            let type = Node.type;
            if (type === "1") {
                this.searchForm.departmentId = "";
                this.searchForm.schoolNum = "";
                this.searchForm.gradeId = '';
                this.searchForm.classId = '';
            }
            if (type === "2") { //学院
                this.searchForm.departmentId = Node.relId;
                this.searchForm.schoolNum = "";
                this.searchForm.gradeId = '';
                this.searchForm.classId = '';
            }
            if (type === "3") { //系
                this.searchForm.departmentId = Node.relId;
                this.searchForm.schoolNum = "";
                this.searchForm.gradeId = '';
                this.searchForm.classId = '';
            }
            if (type === "4") { //年级gradeId
                this.searchForm.gradeId = Node.relId;
                if(this.$refs.classtree.getNode(Node.parentId).data.type == 6) {
                    this.searchForm.schoolNum = this.$refs.classtree.getNode(Node.parentId).data.relId;
                } else {
                    this.searchForm.schoolNum = "";
                }
                this.searchForm.departmentId = '';
                this.searchForm.classId = '';
            }
            if (type === "5") { //班级 classId
                this.searchForm.classId = Node.relId;
                // this.searchForm.schoolNum = Node.schoolNum;
                this.searchForm.schoolNum = "";
                this.searchForm.departmentId = '';
                this.searchForm.gradeId = '';
            }
            if (type === "6") { //班级 classId
                this.searchForm.classId = "";
                // this.searchForm.schoolNum = Node.schoolNum;
                this.searchForm.schoolNum = Node.relId;
                this.searchForm.departmentId = '';
                this.searchForm.gradeId = '';
            }
            this.search();
        },

        formatSex (row) {
            if (row.sex === '1') {
                return '男';
            } else if (row.sex === '2') {
                return '女';
            } else if (row.sex === '3') {
                return '其它';
            }
        },
        querySchoolRelationTree () {
            let user = session('user');
            Api.common.querySchoolRelationTree(user.schoolId).then(res => {
                // let treedata = [];
                // treedata.push(res.data)
                this.classtreeData = res.data;
            })
        },
        cancelFormEdit (dialog, form) {
            this[dialog] = false;
            // this.$refs[form].resetFields();
        },
        comfirmRoomEdit () {
            this.$refs.roomEditForm.validate((valid, obj) => {
                if (valid) {
                    this.showRoomEditDialog = false;
                } else {
                    this.$message('请按要求填写完成后再提交！');
                    return false;
                }

            });
        },
        closeDialog (done) {
            done();
        },
        AutomaticLodging () {
            this.searchForm.houseId = '';
            this.houseCountNum = 0;
            this.showRoomEditDialog = true;
            this.searchType = 'auto';
            if (this.searchForm.search != "") {   //自动排宿时不需带关键字条件查询用户数
                this.userTotal = 0;
                this.searchForm.search = "";
                this.loadData();
            }
            this.isAutoFlagBtn = true;
            this.getAllHouseBySchool();
        },

        BatchOccupancy () {
            this.tableData1 = [];
            this.searchType = 'ruzhu';
            if (this.selStudent != null && this.selStudent.length != 0) {
                this.tableData1 = this.selStudent;
                this.ruzhuType = 'batch';
                // this.formData = {};
                // this.dormitoryList = [];
                // this.restBedSize = 0;
                // this.selBedSize = 0;
                // if (this.roleCode === 'housekeeper') {
                //   this.queryHouseByManagerUser();
                // } else if (this.roleCode === 'admin') {
                //   this.querySchoolCapmus();
                // }
                this.batchOpt();
                this.showBatchOccupancyDialog = true;
                this.$nextTick(() => {
                    this.$refs.table1.toggleAllSelection(true); //官网方法，重点。
                });

            } else {
                this.page = 1;
                this.size = 100;
                this.searchForm.search = "";  //批量入住时不需带关键字条件查询
                this.ruzhuType = "batch2";
                this.loadData().then(() => {
                    this.showBatchOccupancyDialog = true;
                    //    this.formData = {};
                    //  this.dormitoryList = [];
                    //  this.restBedSize = 0;
                    //  this.selBedSize = 0;
                    //    if (this.roleCode === 'housekeeper') {
                    //      this.queryHouseByManagerUser();
                    //    } else if (this.roleCode === 'admin') {
                    //      this.querySchoolCapmus();
                    //    }
                    //  this.$nextTick(() => {
                    //    this.$refs.table1.toggleAllSelection(true); //官网方法，重点。
                    // });
                    this.batchOpt();

                });
            }



        },

        batchOpt () {

            this.formData = {};
            this.dormitoryList = [];
            this.restBedSize = 0;
            this.selBedSize = 0;
            if (this.roleCode === 'housekeeper') {
                this.queryHouseByManagerUser();
            } else if (this.roleCode === 'admin' || this.roleCode === 'logisticsadmin') {
                this.querySchoolCapmus();
            }
            this.$nextTick(() => {
                this.$refs.table1.toggleAllSelection(true); //官网方法，重点。
            });

        },



        getAllHouseBySchool () {
            let user = session('user');
            let schoolId = user.schoolId;
            this.searchForm.schoolId = schoolId;
            if (this.roleCode === 'housekeeper') {
                Api.summary.queryHouseByManagerUser().then(res => {
                    let data = res.data;
                    let option = [];
                    data.map(x => {
                        let obj = {};
                        obj.value = x.houseId;
                        obj.label = x.houseName;
                        option.push(obj);
                    });
                    this.houseOptions1 = option;
                });
            } else if (this.roleCode === 'admin' || this.roleCode === 'logisticsadmin') {
                let str = "schoolId=" + schoolId;
                Api.AccommodationManagement.getAllHouseBySchool(str).then((res) => { //查询该学校所有楼栋信息
                    let data = res.data;
                    let option = [];
                    if (data) {
                        data.map(e => {
                            let o = {};
                            o.label = e.houseName;
                            o.value = e.houseId;
                            option.push(o);
                        });
                    }
                    this.houseOptions1 = option;

                });
            }
        },


    },
    mounted () {

    },
    created () {
        this.querySchoolRelationTree();
        let user = session('user');
        this.roleCode = user.tsr.roleCode;
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.accommodationArrangement {
  .attendanceQuery {
    padding-top: 20px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    border-bottom: none;
    float: right;
    .el-form-item {
      height: 50px;
      margin-bottom: 10px;
      margin-right: 20px;
      font-size: 12x;
      .el-form-item__label {
        color: #666;
      }
      .el-input {
        width: auto;
      }
      .el-input__inner {
        padding: 0px 10px;
        margin-top: 12px;
      }
      .combotree {
        position: absolute;
        left: 0;
        top: 36px;
        z-index: 19920104;
        overflow: auto;
        height: 300px;
        min-width: 170px;
      }
    }
  }

  .import-dialog {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .rel-import-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      .import-btn {
        position: absolute;
        left: 0;
        width: 140px;
        height: 30px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }
    }
  }

  .leftmenu {
    width: 100%;
    display: block;
    margin-top: 20px;
    border: 1px solid #cccccc;
    .title {
      width: 100%;
      background: #25aef4;
      font-size: 12px;
      color: white;
      line-height: 40px;
      height: 40px;
      position: relative;
      text-indent: 1em;
      .res-booklist {
        position: absolute;
        width: 100%;
        height: 200px;
        overflow-y: auto;
        background: #fff;
        top: 43px;
        left: 0;
      }
    }
    .treepanel {
      width: 100%;
    }
  }

  .righttable {
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .autops {
    .el-checkbox + .el-checkbox {
      margin-left: 0px;
    }
    .el-form-item {
      margin: 5px 0 5px 0;
    }
  }

  .autops {
    .el-checkbox + .el-checkbox {
      margin-left: 0px;
    }
    .ruzhusushe {
      min-height: 468px;
      li {
        text-align: center;
        width: 102px;
        height: 102px;
        position: relative;
        float: left;
        margin: 0 23px 30px 23px;
        cursor: pointer;
        p {
          padding: 0;
          margin: 0;
          font-size: 12px;
        }
        .sushehao {
          position: absolute;
          color: white;
          font-size: 12px;
          top: 43px;
          left: 36px;
          z-index: 500;
        }
        .limask {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: black;
          opacity: 0.2;
          z-index: 501;
        }
        .badgeimage {
          margin-top: 5px;
        }
        .selected {
          position: absolute;
          margin-top: -24px;
          top: 50%;
          left: 50%;
          margin-left: -24px;
          z-index: 502;
        }
      }
    }
  }

  .studentname {
    color: #26aef3;
    cursor: pointer;
  }

  .down-tepmlate {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('/static/images/accommodationManagement/down.png') 0 0
        no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }

  .stuInhouse {
    overflow: auto;
    border: 1px dashed #cccccc;
    height: 570px;
    // .el-table__body-wrapper {
    //   width: 615px;
    // }
    // .el-table__header-wrapper {
    //   width: 615px;
    // }
    &.el-table--border::after,
    &.el-table--group::after {
      background-color: transparent;
    }
    &.el-table--border::after,
    &.el-table--group::after,
    &.el-table::before {
      background-color: transparent;
    }
    .el-table--scrollable-x .el-table__body-wrapper {
        min-height: 528px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/accommodationManagement/accommodationArrangement.vue